import templateUrl from "emun.auth/register-consumer.prompt.htm";
import open from "webmodals/open";
import modals from "webmodals/modals";
import config from "emun.auth/auth.config";

class controller {
	constructor($session, $scope, options, $window) {
		const $ctrl = this;
		$ctrl.title = options.title || " Registration..";
		$ctrl.consumer = options.consumer;
		$scope.$on("$consumerRequestSubmitted", res => {
			$ctrl.$dismiss(res);
			$window.location.reload();
			//if (!$session.isSalesManagementMode()) {
			//	modals.dialog(config.registrationSuccessfulModal);
			//}
		});
	}
}

export default options =>
	open({
		size: options.size || "lg",
		backdrop: "static",
		templateUrl: options.templateUrl || templateUrl,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			options: () => options
		}
	}).result;
